import React, { useState } from "react";
import axios from "axios";
import { CreateData } from "../../../services/process/process_data/process_data";

const PROGRAMS = [
  "MBA", "BBA", "B.Tech", "M.Tech", "MCA", "BCA",
  "B.Sc", "M.Sc", "BA", "MA", "LLB", "B.Com", "M.Com"
];

const QUALIFICATIONS = [
  "10th Pass", "12th Pass", "Diploma", "Bachelor's Degree",
  "Master's Degree", "PhD", "Other"
];

const INTAKES = [
  "Jan 2026", "Apr 2026", "Jul 2026", "Oct 2026",
  "Jan 2027", "Apr 2027", "Jul 2027"
];

const CITIES = [
  "Mumbai", "Delhi", "Bengaluru", "Chennai", "Hyderabad",
  "Pune", "Kolkata", "Ahmedabad", "Jaipur", "Other"
];

const initialForm = {
  full_name: "",
  email: "",
  mobile_number: "",
  city: "",
  city_other: "",
  academic_qualification: "",
  program_interest: "",
  intake: "",
  consent: false,
};
const Field = ({ label, name, children, required, errors }) => (
  <div style={styles.field}>
    <label style={styles.label}>
      {label} {required && <span style={{ color: "#e05454" }}>*</span>}
    </label>
    {children}
    {errors?.[name] && (
      <span style={styles.errorText}>{errors[name]}</span>
    )}
  </div>
);

function LeadEnrollmentForm() {
  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(null); // 'success' | 'error' | null
  const [loading, setLoading] = useState(false);
  const [userCredentials] = useState(
    JSON.parse(sessionStorage.getItem("userCredentials") || "{}")
  );

  const validate = () => {
    const newErrors = {};
    if (!formData.full_name.trim()) newErrors.full_name = "Full name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }
    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile_number)) {
      newErrors.mobile_number = "Enter a valid 10-digit mobile number";
    }
    if (!formData.city) newErrors.city = "Please select a city";
    if (formData.city === "Other" && !formData.city_other.trim()) newErrors.city_other = "Please enter your city";
    if (!formData.academic_qualification) newErrors.academic_qualification = "Please select qualification";
    if (!formData.program_interest) newErrors.program_interest = "Please select a program";
    if (!formData.intake) newErrors.intake = "Please select an intake";
    if (!formData.consent) newErrors.consent = "You must agree to proceed";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => {
      const updated = { ...prev, [name]: type === "checkbox" ? checked : value };
      if (name === "city" && value !== "Other") updated.city_other = "";
      return updated;
    });
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const getFormattedDate = () => new Date().toISOString().slice(0, 19).replace("T", " ");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setStatus(null);

    try {
      const now = getFormattedDate();
      const payload = {
        database: "education",
        table: "lead_enrollments",
        formData: {
          full_name: formData.full_name.trim(),
          email: formData.email.trim().toLowerCase(),
          mobile_number: formData.mobile_number.trim(),
          city: formData.city === "Other" ? formData.city_other.trim() : formData.city,
          academic_qualification: formData.academic_qualification,
          program_interest: formData.program_interest,
          intake: formData.intake,
          consent: formData.consent ? 1 : 0,
          created_on: now,
          last_updated_on: now,
          entity_id: userCredentials.selectedentity || null,
          created_by: userCredentials.user_id || null,
          is_active: 1,
        },
      };

      const credentials = CreateData();
      await axios.post(credentials[1], payload, credentials[0]);
      setStatus("success");
      setFormData(initialForm);
    } catch (err) {
      console.error("Submission error:", err);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };


  const inputStyle = (name) => ({
    ...styles.input,
    ...(errors[name] ? styles.inputError : {}),
  });

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerAccent} />
          <div style={styles.headerContent}>
            <p style={styles.headerEyebrow}>Admissions 2026-27</p>
            <h1 style={styles.headerTitle}>Start Your Journey</h1>
            <p style={styles.headerSub}>
              Fill in your details and our counsellors will reach out within 24 hours.
            </p>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={styles.form} noValidate>
          <div style={styles.grid2}>
            <Field label="Full Name" name="full_name" required errors={errors}>
              <input
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                placeholder="e.g. Rahul Sharma"
                style={inputStyle("full_name")}
              />
            </Field>

            <Field label="Email Address" name="email" required errors={errors}>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@example.com"
                style={inputStyle("email")}
              />
            </Field>

            <Field label="Mobile Number" name="mobile_number" required errors={errors}>
              <div style={styles.phoneWrapper}>
                <span style={styles.phonePrefix}>+91</span>
                <input
                  name="mobile_number"
                  value={formData.mobile_number}
                  onChange={handleChange}
                  placeholder="10-digit number"
                  maxLength={10}
                  style={{ ...inputStyle("mobile_number"), borderRadius: "0 8px 8px 0", borderLeft: "none" }}
                />
              </div>
            </Field>

            <Field label="City" name="city" required errors={errors}>
              <select name="city" value={formData.city} onChange={handleChange} style={inputStyle("city")}>
                <option value="">Select your city</option>
                {CITIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </Field>

            <div style={{ display: formData.city === "Other" ? "flex" : "none", flexDirection: "column", gap: "6px" }}>
              <label style={styles.label}>Enter Your City <span style={{ color: "#e05454" }}>*</span></label>
              <input
                name="city_other"
                value={formData.city_other}
                onChange={handleChange}
                placeholder="Type your city name"
                style={inputStyle("city_other")}
              />
              {errors.city_other && <span style={styles.errorText}>{errors.city_other}</span>}
            </div>

            <Field label="Academic Qualification" name="academic_qualification" required errors={errors}>
              <select name="academic_qualification" value={formData.academic_qualification} onChange={handleChange} style={inputStyle("academic_qualification")}>
                <option value="">Select qualification</option>
                {QUALIFICATIONS.map((q) => <option key={q} value={q}>{q}</option>)}
              </select>
            </Field>

            <Field label="Program Interest" name="program_interest" required errors={errors}>
              <select name="program_interest" value={formData.program_interest} onChange={handleChange} style={inputStyle("program_interest")}>
                <option value="">Select program</option>
                {PROGRAMS.map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
            </Field>
          </div>

          <Field label="Preferred Intake" name="intake" required errors={errors}>
            <div style={styles.intakeGrid}>
              {INTAKES.map((intake) => (
                <label key={intake} style={{
                  ...styles.intakeOption,
                  ...(formData.intake === intake ? styles.intakeSelected : {})
                }}>
                  <input
                    type="radio"
                    name="intake"
                    value={intake}
                    checked={formData.intake === intake}
                    onChange={handleChange}
                    style={{ display: "none" }}
                  />
                  {intake}
                </label>
              ))}
            </div>
            {errors.intake && <span style={styles.errorText}>{errors.intake}</span>}
          </Field>

          {/* Consent */}
          <div style={styles.consentRow}>
            <label style={styles.consentLabel}>
              <div style={{
                ...styles.checkbox,
                ...(formData.consent ? styles.checkboxChecked : {})
              }}>
                <input
                  type="checkbox"
                  name="consent"
                  checked={formData.consent}
                  onChange={handleChange}
                  style={{ display: "none" }}
                />
                {formData.consent && (
                  <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
                    <path d="M1 4L4.5 7.5L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </div>
              <span style={styles.consentText}>
                I agree to be contacted by the admissions team via call, SMS, or email regarding my
                application. I have read and accept the{" "}
                <a href="#" style={styles.link}>Privacy Policy</a> and{" "}
                <a href="#" style={styles.link}>Terms of Use</a>.
              </span>
            </label>
            {errors.consent && <span style={{ ...styles.errorText, display: "block", marginTop: "6px" }}>{errors.consent}</span>}
          </div>

          {/* Status messages */}
          {status === "success" && (
            <div style={styles.successBanner}>
              <span style={{ fontSize: "20px" }}>🎉</span>
              <div>
                <strong>Application received!</strong>
                <p style={{ margin: "2px 0 0", fontSize: "13px" }}>
                  Our counsellor will contact you within 24 hours.
                </p>
              </div>
            </div>
          )}
          {status === "error" && (
            <div style={styles.errorBanner}>
              <span>⚠️</span>
              <div>
                <strong>Submission failed.</strong>
                <p style={{ margin: "2px 0 0", fontSize: "13px" }}>Please try again or contact support.</p>
              </div>
            </div>
          )}

          <button type="submit" style={{ ...styles.submitBtn, ...(loading ? styles.submitBtnLoading : {}) }} disabled={loading}>
            {loading ? (
              <span style={styles.spinner} />
            ) : (
              <>Submit Application <span style={{ marginLeft: "8px" }}>→</span></>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

/* ─── Styles ────────────────────────────────────────────────── */
const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0f1b35 0%, #1a3160 50%, #0f1b35 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px 16px",
    fontFamily: "'Georgia', 'Times New Roman', serif",
  },
  card: {
    background: "#ffffff",
    borderRadius: "16px",
    width: "100%",
    maxWidth: "780px",
    overflow: "hidden",
    boxShadow: "0 32px 80px rgba(0,0,0,0.4)",
  },
  header: {
    position: "relative",
    background: "linear-gradient(135deg, #0f1b35, #1e3a6e)",
    padding: "40px 40px 36px",
    overflow: "hidden",
  },
  headerAccent: {
    position: "absolute",
    top: "-40px",
    right: "-40px",
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.04)",
  },
  headerContent: { position: "relative", zIndex: 1 },
  headerEyebrow: {
    color: "#90aee0",
    fontSize: "12px",
    letterSpacing: "3px",
    textTransform: "uppercase",
    margin: "0 0 10px",
    fontFamily: "'Arial', sans-serif",
  },
  headerTitle: {
    color: "#ffffff",
    fontSize: "32px",
    fontWeight: "700",
    margin: "0 0 10px",
    letterSpacing: "-0.5px",
  },
  headerSub: {
    color: "#a8bfdf",
    fontSize: "14px",
    margin: 0,
    fontFamily: "'Arial', sans-serif",
    lineHeight: 1.5,
  },
  form: { padding: "36px 40px 40px" },
  grid2: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px 24px",
    marginBottom: "20px",
  },
  field: { display: "flex", flexDirection: "column", gap: "6px" },
  label: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#2d3a52",
    letterSpacing: "0.3px",
    fontFamily: "'Arial', sans-serif",
  },
  input: {
    height: "42px",
    padding: "0 14px",
    border: "1.5px solid #dde2ee",
    borderRadius: "8px",
    fontSize: "14px",
    color: "#1a1a2e",
    outline: "none",
    background: "#f9fafc",
    transition: "border-color 0.2s",
    fontFamily: "'Arial', sans-serif",
    width: "100%",
    boxSizing: "border-box",
  },
  inputError: { borderColor: "#e05454", background: "#fff8f8" },
  errorText: { color: "#e05454", fontSize: "11.5px", fontFamily: "'Arial', sans-serif" },
  phoneWrapper: { display: "flex", alignItems: "stretch" },
  phonePrefix: {
    display: "flex",
    alignItems: "center",
    padding: "0 12px",
    background: "#eef0f8",
    border: "1.5px solid #dde2ee",
    borderRight: "none",
    borderRadius: "8px 0 0 8px",
    fontSize: "14px",
    color: "#5a6480",
    fontFamily: "'Arial', sans-serif",
    whiteSpace: "nowrap",
  },
  intakeGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginTop: "4px",
  },
  intakeOption: {
    padding: "8px 16px",
    border: "1.5px solid #dde2ee",
    borderRadius: "20px",
    fontSize: "13px",
    color: "#4a5568",
    cursor: "pointer",
    userSelect: "none",
    background: "#f9fafc",
    transition: "all 0.15s",
    fontFamily: "'Arial', sans-serif",
  },
  intakeSelected: {
    background: "#0f1b35",
    borderColor: "#0f1b35",
    color: "#ffffff",
    fontWeight: "600",
  },
  consentRow: { margin: "24px 0" },
  consentLabel: { display: "flex", gap: "12px", cursor: "pointer", alignItems: "flex-start" },
  checkbox: {
    width: "20px",
    height: "20px",
    minWidth: "20px",
    border: "2px solid #c0c8de",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1px",
    transition: "all 0.15s",
    background: "#fff",
  },
  checkboxChecked: { background: "#0f1b35", borderColor: "#0f1b35" },
  consentText: {
    fontSize: "13px",
    color: "#4a5568",
    lineHeight: "1.55",
    fontFamily: "'Arial', sans-serif",
  },
  link: { color: "#1e3a6e", textDecoration: "underline" },
  successBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    background: "#f0fdf4",
    border: "1px solid #86efac",
    borderRadius: "10px",
    padding: "14px 18px",
    marginBottom: "20px",
    fontSize: "14px",
    color: "#166534",
    fontFamily: "'Arial', sans-serif",
  },
  errorBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    background: "#fff8f8",
    border: "1px solid #fca5a5",
    borderRadius: "10px",
    padding: "14px 18px",
    marginBottom: "20px",
    fontSize: "14px",
    color: "#991b1b",
    fontFamily: "'Arial', sans-serif",
  },
  submitBtn: {
    width: "100%",
    height: "50px",
    background: "linear-gradient(135deg, #0f1b35, #1e3a6e)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "15px",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    letterSpacing: "0.5px",
    transition: "opacity 0.2s",
    fontFamily: "'Arial', sans-serif",
  },
  submitBtnLoading: { opacity: 0.7, cursor: "not-allowed" },
  spinner: {
    width: "20px",
    height: "20px",
    border: "2px solid rgba(255,255,255,0.3)",
    borderTop: "2px solid #fff",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
};

export default LeadEnrollmentForm;